import { CheckableList } from 'components/CheckableList/CheckableList'
import { ChipsContainer } from 'components/CheckBox/CheckBox.styled'
import { CheckChip } from 'components/CheckBox/CheckChip'
import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { days } from 'pages/Employees/employeesData'
import { useState } from 'react'
import { Button, Flex, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'

export const Recurrence = ({ setStep, setState, state }: { setStep: (step: number) => void, setState?: any, state: any }) => {
    const [frequency, setFrequency] = useState<'everyShift' | 'daily' | 'weekly' | 'custom'>('everyShift')
    const [selectedDays, setSelectedDays] = useState<number[]>([])
    const [selectedShifts, setSelectedShifts] = useState<ISelectValue[]>(state?.shifts ?? [])

    const handleShiftsChange = (shifts: ISelectValue[]) => {
        setSelectedShifts(shifts)
        setState?.((prev: Record<string, unknown>) => ({ ...prev, shifts }))
    }

    const parseShifts = (data: { data: { id: number; name: string }[] }) =>
        data.data.map((shift) => ({ label: shift.name, value: shift.id }))

    const handleNext = () => setStep(4)
    const handleBack = () => setStep(2)

    const handleSelectDay = (day: number) => {
        setSelectedDays(prev => prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day])
    }


    return <>
        <Flex width='100%' gap='1rem' >
            <Container>
                <ContainerHeader>
                    <TitleText>Frequency</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <TabsContainer style={{ marginBottom: '1rem' }}>
                        <Tabs onClick={() => setFrequency('everyShift')} active={frequency === 'everyShift'}>Every Shift</Tabs>
                        <Tabs onClick={() => setFrequency('daily')} active={frequency === 'daily'}>Daily</Tabs>
                        <Tabs onClick={() => setFrequency('weekly')} active={frequency === 'weekly'}>Weekly</Tabs>
                        <Tabs onClick={() => setFrequency('custom')} active={frequency === 'custom'}>Custom</Tabs>
                    </TabsContainer>
                    {frequency == 'weekly' ? <>
                        <BodyText style={{ marginBottom: '1rem' }} >Select Days</BodyText>
                        <ChipsContainer>
                            {days
                                .map(d => <CheckChip key={d.value} active={selectedDays.includes(d.value)} onClick={() => handleSelectDay(d.value)} text={d.label} />)}
                        </ChipsContainer>
                    </> : frequency === 'custom' ? <Input placeholder='4..' type='number' labelText='Custom interval (days)' name='interval' /> : <></>}

                </ContainerContent>

            </Container>
            <Container >
                <ContainerHeader>
                    <TitleText>Shifts</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <CheckableList
                        link='shifts'
                        parserFunction={parseShifts}
                        searchEnabled
                        searchPlaceholder='Search shifts...'
                        selected={selectedShifts}
                        onChange={handleShiftsChange}
                        selectedLabelText='Selected shifts'
                        selectedPlaceholder='No shifts selected'
                        listMaxHeight='16rem'
                    />
                </ContainerContent>
            </Container>
        </Flex>
        <Flex gap='1rem' mt='32' justend>
            <Button onClick={handleBack}>Back</Button>
            <Button orange onClick={handleNext} >Next</Button>
        </Flex>
    </>

}